/*
 * @Author: your name
 * @Date: 2020-04-22 11:25:39
 * @LastEditTime: 2020-04-27 10:50:08
 * @LastEditors: Fan
 * @Description: In User Settings Edit
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\ImageUpload\schema.ts
 */
import { baseUploadOptions } from "../../../../form/component-schema";
import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    $id: "picture-card",
    type: DataType.Object,
    $ref: baseUploadOptions.$id,
    properties: {
        widgetType: {
            type: DataType.Number,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        number: {
            type: DataType.String,
            title: i18n.t('dataitem.UploadQuantity').toString(),
            default: "batch",
        },
        addWatermark: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.Watermark').toString(),
        },
        watermarkFontSize: {
            type: DataType.Number,
            title: i18n.t('dataitem.WatermarkFontSize').toString(),
        },
        imageQuality: {
            type: DataType.Integer,
            title: i18n.t('dataitem.ImageQuality').toString(),
            default: 30,
        },
        compressible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.Compress').toString(),
        },
        onlyShoot: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.OnlyPhoto').toString(),
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
    },
};
